import React, { createContext, useCallback, useContext, useState } from "react";

const ToastCtx = createContext({ push: () => {} });

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const push = useCallback((msg, type = "info") => {
    const id = Math.random().toString(36).slice(2);
    setToasts((t) => [...t, { id, msg, type }]);
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 4000);
  }, []);
  return (
    <ToastCtx.Provider value={{ push }}>
      {children}
      <div className="fixed z-[100] bottom-6 right-6 flex flex-col gap-2" data-testid="toast-root">
        {toasts.map((t) => (
          <div
            key={t.id}
            className="card px-4 py-3 text-sm max-w-xs"
            style={{
              background: t.type === "error" ? "#fee" : "var(--card)",
              borderColor: t.type === "error" ? "#fbb" : "var(--border)",
              color: t.type === "error" ? "#8a1f1f" : "var(--fg)",
            }}
          >
            {t.msg}
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}

export const useToast = () => useContext(ToastCtx);
